import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import ManualLeadForm from "@/components/ManualLeadForm";
import TeamLayout from "@/components/TeamLayout";
import { teamApi } from "@/lib/api";

export default function TeamLog() {
  const [auth, setAuth] = useState({ loading: true, ok: false });
  const [me, setMe] = useState(null);
  const [toast] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    teamApi.me()
      .then((r) => { setMe(r.data); setAuth({ loading: false, ok: true }); })
      .catch(() => setAuth({ loading: false, ok: false }));
  }, []);

  if (auth.loading) return <div style={{ padding: 40 }}>{"Loading\u2026"}</div>;
  if (!auth.ok) return <Navigate to="/team/login" replace />;

  const handleSubmit = async (form) => {
    await teamApi.manualLead(form);
    // Carry a one-shot success toast across the navigation. /team reads
    // and clears it on mount (legacy sessionStorage hand-off).
    try { sessionStorage.setItem("scw_lead_toast", "Lead logged"); } catch { /* ignore */ }
    nav("/team");
  };

  return (
    <TeamLayout pageTitle="Log a Lead — SCW Contact Hub">
      <div data-testid="team-log-page" style={{ maxWidth: 720 }}>
        <p className="scw-eyebrow" style={{ marginBottom: 8 }}>Manual entry</p>
        <h1 style={{ fontSize: 28, margin: "0 0 8px 0" }}>Log a lead</h1>
        <p style={{ fontSize: 14, color: "var(--scw-muted)", marginTop: 0, marginBottom: 28 }}>
          For enquiries that arrived via WhatsApp DM, Instagram, phone, or in person {"\u2014"} anything not captured by the public contact form.
          Lead owner will be set to <strong>{me?.name || "you"}</strong> automatically.
        </p>
        {toast && <p style={{ color: "#3a7d3a", fontSize: 13, marginBottom: 12 }}>{toast}</p>}
        <ManualLeadForm onSubmit={handleSubmit} onCancel={() => nav("/team")} submitLabel="Log lead" />
      </div>
    </TeamLayout>
  );
}
